import { str } from "crc-32";

export class Variant {
  constructor(value, percentage) {
    this.Value = value;
    this.Percentage = percentage;
  }
}

export class Release {
  constructor(name, variants) {
    this.Name = name;
    this.Variants = variants;
    this.allocations = {};
    this.createAllocations();
  }

  createAllocations() {
    let a = 0;
    for (const v of this.Variants) {
      for (let i = 0; i < v.Percentage; i++) {
        this.allocations[a] = v.Value;
        a++;
      }
    }
  }

  GetValue() {
    const id = this.GetSessionId();
    const h = str(id.toString()) >>> 0;
    const i = h.toString().substr(-2);

    const s = parseInt(i);
    if (isNaN(s)) {
      s = 0;
    }

    return this.allocations[s];
  }

  GetSessionId() {
    const sessionCookieName = "_gid";
    return CookieJar.Get(sessionCookieName, "nosession");
  }
}

export class FeatureRelease {
  constructor(name, variants) {
    this.Name = name;
    this.Variants = variants;
  }

  Get() {
    const cookieName = this.GetCookieName();
    var cookieValue = CookieJar.Get(cookieName, false);

    if (cookieValue !== false) {
      return cookieValue;
    }

    const variants = [];
    for (const [key, value] of Object.entries(this.Variants)) {
      variants.push(new Variant(key, value));
    }
    const r = new Release(this.Name, variants);
    cookieValue = r.GetValue();
    CookieJar.Set(cookieName, cookieValue);

    return cookieValue;
  }

  GetCookieName() {
    return `feature-${this.Name}`;
  }
}

export class CookieJar {
  static Get(name, defaultValue) {
    var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    if (match) {
      return match[2];
    }

    return defaultValue;
  }

  static Set(name, value) {
    document.cookie = `${name}=${value}; path=/; expires=${new Date(
      86400000 + Date.now()
    ).toUTCString()};`;
  }
}
